export default __webpack_public_path__ + "static/media/youtubeNew.8eccfe47.svg";